import axios from "axios";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    withCredentials: true
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem("token");
            window.location.href = "/login";
        }
        return Promise.reject(error);
    }
);

const getAuthHeader = () => {
    const token = localStorage.getItem("token");
    return {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `bearer ${token}`
        }
    };
};


export async function getAcessCountGraph(startDate: string, endDate: string, setIsLoading: (value: boolean) => void, setAccessData: (data: any) => void) {
    setIsLoading(true);
    try {
        const body = {
            start_date: `${startDate} GMT-03`,
            end_date: `${endDate} GMT-03`,
        };

        const response = await api.post("/dashboard/date-accesses", body, getAuthHeader());

        const formattedData = response.data.map((item: any) => ({
            date: item.date.split('T')[0],
            accesses: item.total
        }));
        setAccessData(formattedData);
    } catch (error) {
        console.error("Erro ao buscar dados do dashboard:", error);
    } finally {
        setIsLoading(false);
    }
}

export async function getScenarioCountGraph(startDate: string, endDate: string, setScenarioData: (data: any) => void) {
    try {
        const body = {
            start_date: `${startDate} GMT-03`,
            end_date: `${endDate} GMT-03`,
        };

        const response = await api.post("/dashboard/scenario-count", body, getAuthHeader());

        const formattedData = response.data.map((item: any) => ({
            name: item.name,
            accessCount: item.total
        }));

        setScenarioData(formattedData);
    } catch (error) {
        console.error("Erro ao buscar dados de cenários:", error);
    }
}

export async function getLogTypeCountGraph(startDate: string, endDate: string, setFeatureData: (data: any) => void) {
    try {
        const body = {
            start_date: `${startDate} GMT-03`,
            end_date: `${endDate} GMT-03`,
        };

        const response = await api.post("/dashboard/log-type-count", body, getAuthHeader());

        const formattedData = response.data.map((item: any) => ({
            key: item.lh_log_type,
            accessCount: item.total
        }));

        setFeatureData(formattedData);
    } catch (error) {
        console.error("Erro ao buscar contagem de tipos de log:", error);
    }
}

export async function getOSCountGraph(startDate: string, endDate: string, setOSData: (data: any) => void) {
    try {
        const body = {
            start_date: `${startDate} GMT-03`,
            end_date: `${endDate} GMT-03`,
        };

        const response = await api.post("/dashboard/new-device-os-count", body, getAuthHeader());

        const formattedData = response.data.map((item: any) => {
            const osName = item.os || "Outros";
            let key = osName.toUpperCase();

            if (key.includes("LINUX") || key.includes("UBUNTU")) key = "LINUX";
            if (key.includes("MAC")) key = "IOS";

            return {
                name: osName,
                key: key,
                accessCount: item.total
            };
        });

        setOSData(formattedData);
    } catch (error) {
        console.error("Erro ao buscar OS count:", error);
    }
}

export async function getBrowserCountGraph(startDate: string, endDate: string, setBrowserData: (data: any) => void) {
    try {
        const body = {
            start_date: `${startDate} GMT-03`,
            end_date: `${endDate} GMT-03`,
        };

        const response = await api.post("/dashboard/new-device-client-count", body, getAuthHeader());

        const formattedData = response.data.map((item: any) => {
            const browserName = item.os || "Outros";
            const nameUpper = browserName.toUpperCase();
            let key = "CHROME";

            if (nameUpper.includes("CHROME")) key = "CHROME";
            else if (nameUpper.includes("FIREFOX")) key = "FIREFOX";
            else if (nameUpper.includes("EDGE")) key = "MS_EDGE";
            else if (nameUpper.includes("OPERA")) key = "OPERA";
            else if (nameUpper.includes("SAFARI")) key = "IOS";

            return {
                name: browserName,
                key: key,
                accessCount: item.total
            };
        });

        setBrowserData(formattedData);
    } catch (error) {
        console.error("Erro ao buscar Browser count:", error);
    }
}

export async function getDeviceTypeCountGraph(startDate: string, endDate: string, setDeviceData: (data: any) => void) {
    try {
        const body = {
            start_date: `${startDate} GMT-03`,
            end_date: `${endDate} GMT-03`,
        };

        const response = await api.post("/dashboard/new-device-type-count", body, getAuthHeader());

        const formattedData = response.data.map((item: any) => {
            const rawName = item.os || "Outros";
            let key = rawName.toUpperCase();

            if (key === "SMARTPHONE") key = "MOBILE";

            return {
                name: rawName.charAt(0).toUpperCase() + rawName.slice(1),
                key: key,
                accessCount: item.total
            };
        });

        setDeviceData(formattedData);
    } catch (error) {
        console.error("Erro ao buscar Device Type count:", error);
    }
}